/* Built In Imports */
import { useState, useRef, useEffect } from 'react';
import NextLink from 'next/link';
/* External Imports */
import { Box, Link, Text, Show, Image } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import parse from 'html-react-parser';
import { nanoid } from 'nanoid';
import { useMediaQuery } from 'react-responsive';
// import { LazyLoadComponent } from 'react-lazy-load-image-component';

/* Internal Imports */
/* Components */
import config from '@config';
import { ShortCodeProcess } from '@components/Utility/ArticleParser/ShortCode';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { refineUrlDomain } from '@components/Utility/utils';
import useDynamicRefs from '@hooks/useDynamicRefs';

/* Services */
/* Styles */
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/**
 * Renders VolunteerSharingTopSliderGroup Component
 *
 * @param {object} sectionContent - Data from api
 * @param {string} region - Region of page
 * @param {string} lang - Language of page
 * @returns
 */

const DonationGroupCard = ({ sectionContent, region, language }) => {
  const [getRef, setRef] = useDynamicRefs();
  const isDesktop = useMediaQuery({ minWidth: 990 });
  const GroupCard1 =  sectionContent[0]?.text == "Raising Human Consciousness";

  const settings = {
    dots: true,
    infinite: false,
    arrows: false,
    lazyLoad: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      <Box maxW={'1200px'} m="0 auto" p={'16px 0 0 0'}>
        <Text
          padding={{ base: '10px 0 15px 30px', md: '10px 0 15px 0px' }}
          fontFamily="'FedraSansStd-book', sans-serif"
          fontSize={'28px'}
          fontWeight={'600'}
          color={'#333333'}
        >
          {sectionContent[0].text}
        </Text>
      </Box>
      <Box
        display="flex"
        borderRadius="5px"
        mb="30px"
        flexDir={{ base: 'column', lg: 'row' }}
        maxW={{
          base: '320px',
          sm: '480px',
          md: '690px',
          lg: '770px',
          xl: '1200px',
        }}
        w="full"
        h="full"
        mx="auto"
        _last={{
          mb: { base: '10', lg: '70' },
        }}
      >
        <Box maxW={{ base: '320px', lg: '514px', xl: '514px' }} w="100%">
          <Box
            bgImage={{
              base: sectionContent[1]?.mobileImage.url,
              md: sectionContent[1]?.image?.url,
            }}
            bgRepeat="no-repeat"
            bgSize="cover"
            w="full"
            h={{ base: '140', md: '240' }}
            pos="relative"
            borderRadius={'6px'}
          ></Box>
        </Box>
        <Box
          display="flex"
          flexDir={{ base: 'column', md: 'row' }}
          gridGap={{ base: '30px', md: '80px' }}
          width={{ base: '100%', md: 'full' }}
          p={{
            base: '24px 15px 12px 15px',
            sm: '27px 30px',
            lg: '0px 48px',
          }}
        >
          <Box w={{ base: '100%', lg: '100%' }}>
            <Box
              lineHeight="26px"
              fontFamily="FedraSansStd-book"
            >
              <StructuredTextParser
                str={render(sectionContent[2].body)}
                region={region}
                lang={language}
                mt="0"
                color={'#28231e'}
                lineHeight={'1.7'}
                fontSize="20px"
                padding={'10px 0'}
                className={'donation-description'}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className='mobile_slider'>
      {isDesktop ? (
        <Box
          display="grid"
          pt="16px"
          gridTemplateColumns="repeat(3, 320px)"
          gap="120px"
          justifyContent="center"
          w="100%"
          mx="auto"
          alignItems={"start"}
        >
          {sectionContent[3].cards.map((card, index) => (
            <DonationCard
              key={index}
              card={card}
              region={region}
              lang={language}
              setRef={setRef}
              index={index}
              groupcard={GroupCard1}
            />
          ))}
        </Box>
      ) : (
        <Slider {...settings}>
          {sectionContent[3].cards.map((card, index) => (
            <Box key={index} style={{ width: '320px', margin: '0 auto' }}>
              <DonationCard
                card={card}
                region={region}
                lang={language}
                setRef={setRef}
                index={index}
                groupcard={GroupCard1}
              />
            </Box>
          ))}
        </Slider>
      )}
      </Box>
      <style>
        {`
          .donation-description {
            margin: 0;
            padding: 0;
          }
          .donation-description p {
            font-size: 20px !important;
            padding: 10px 0;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: inherit;
            color: #28231e
          }
          .mobile_slider .slick-dots {
            position: relative;
            bottom: 25px;
          }
          .mobile_slider .slick-dots li {
            width: 20px;
            height: 20px;
            padding: 0 3px !important;
            margin: 5px auto !important;
          }
          .mobile_slider .slick-dots li button {
            width: 15px;
            height: 15px;
          }
          .mobile_slider .slick-dots li button:before {
            font-size: 12px;
          }
          .slick-dots li.slick-active button:before {
            color: #CF4520;
          }
        `}
      </style>
    </>
  );
};

const DonationCard = ({ card, region, lang, setRef, index, groupcard }) => {
  let readLessTxtCount = '';
  const descText = card?.description.value.document.children[0].children[0].value;

  if (index == 0) {
    readLessTxtCount = 140;
  }
  else if (index == 1) {
    readLessTxtCount = 140;
  }
  else if (index == 2) {
    readLessTxtCount = 140;
  }
  else if (index == 3) {
    readLessTxtCount = 132;
  }
  else if (index == 4) {
    readLessTxtCount = 134;
  }
  const [showMore, setShowMore] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef(null);


  const ReadMoreLess = ({ text, lines = 4 }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const textRef = useRef(null);
  
    useEffect(() => {
      if (textRef.current) {
        const lineHeight = parseFloat(getComputedStyle(textRef.current).lineHeight);
        const maxHeight = lineHeight * lines;
        setIsOverflowing(textRef.current.scrollHeight > maxHeight);
      }
    }, []);
  
    return (
      <div className="max-w-md">
        <Box as="p"
          ref={textRef}
          className={`overflow-hidden transition-all ${isExpanded ? "line-clamp-none" : ""}`}
          style={{
            display: "-webkit-box",
            WebkitLineClamp: isExpanded ? "unset" : lines,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {text}
        </Box>
  
        {isOverflowing && (
          <button
            className="readmore mt-2 cursor-pointer"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? "Read Less" : "Read More"}
          </button>
        )}
      </div>
    );
  };
  

  const ctaButton = (buttonText, buttonLink, indx, groupcard) => {
    const icon1 = `${config.imgPath}/d/46272/1741785431-icon-educate-a-child-svg.svg`;
    const icon2 = `${config.imgPath}/d/46272/1741785431-icon-plant-a-tree-svg.svg`;
    const icon3 = `${config.imgPath}/d/46272/1741785431-icon-help-rural-communities-svg.svg`;
    let buttonUrl = '';
    buttonUrl = ShortCodeProcess(buttonLink.toString());
    buttonUrl = parse(buttonUrl);
    return (
      <NextLink
        href={refineUrlDomain(buttonUrl, region, lang)}
        passHref
        legacyBehavior
      >
        <Link
          mb={{ md: '10px', base: '16px' }}
          display="flex"
          justifyContent="center"
          alignItems="center"
          fontWeight={500}
          fontFamily="FedraSansStd-medium"
          fontSize="16px"
          bgColor="orange.50"
          textAlign="center"
          padding="10px"
          borderRadius="3px"
          color="white"
          textDecoration="none"
          _hover={{
            bg: 'blue.50',
          }}
          cursor="pointer"
          width={'290px'}
          m="0 auto"
          height={{ base: '46px', md: '46px' }}
        >
          {!groupcard && (<Image
            src={
              indx === 0 ? icon1 : indx === 1 ? icon2 : indx === 2 ? icon3 : ''
            }
            alt=""
            title=""
            pr="5px"
          />)}
          {buttonText}
        </Link>
      </NextLink>
    );
  };

  return (
    <>
      <Box
        as="article"
        display="flex"
        flexDir={{ base: 'column', lg: 'column' }}
        bgColor="#F5F5F5"
        borderRadius="5px"
        mb="30px"
        w="320px"
        minH={'550px'}
        mx="auto"
        justifyItems={'stretch'}
      >
        <Box maxW="320px" w="100%">
          <Box
            bgImage={{
              base: card.mobileThumbnail?.url,
              lg: card.thumbnail?.url,
            }}
            bgRepeat="no-repeat"
            bgSize="cover"
            w="320px"
            h={'220px'}
            pos="relative"
            borderRadius={'6px 6px 0 0'}
          >
            {card.isFeatured && (
              <Box
                pos="absolute"
                bgColor="#CF4520"
                color="#fff"
                top="10px"
                fontSize="16px"
                p="0px 4px 0px 10px"
              >
                Featured
              </Box>
            )}
          </Box>
        </Box>

        <Box display="flex" flexDir="column" p="15px" maxW="320px" w="100%">
          <Box
            as="h2"
            fontWeight="600"
            height="75px"
            fontFamily="FedraSansStd-book"
            fontSize={{ base: '22px', md: '22px' }}
            display="flex"
            alignItems="center"
            justifyContent="left"
          >
            {card.title}
          </Box>
          
          {/* <Box as="p" lineHeight="30px" ref={textRef} 
            style={{ maxHeight: showMore ? 'none' : '125px', overflow: 'hidden' }}>
            <StructuredTextParser region={region} lang={lang} 
              str={showMore ? descText : descText.slice(0, readLessTxtCount) + '...'} 
              className="card_description" />
          </Box>

          {isOverflowing && (
            <Box
              color="#CF4520"
              fontSize="16px"
              pt="10px"
              pb="10px"
              onClick={() => setShowMore(!showMore)}
              cursor="pointer"
              textAlign="left"
              className="readmoreless"
            >
              {showMore ? 'Read Less' : 'Read More'}
            </Box>
          )} */}
          <Box as="p" lineHeight="30px" className="card_description">
            <ReadMoreLess text={descText} lines={4} />
          </Box>

          {card.buttonText && (
            <Box mt="5px">{ctaButton(card?.buttonText, card?.buttonLink, index, groupcard)}</Box>
          )}
        </Box>
        <style>
          {`
            .card_description {
              margin-top: 0px;
              min-height: 150px;
            }
            .card_description p {
              line-height: 30px;
              width: 274px;
              font-family: FedraSansStd-book;
            }
            .readmore {
              font-family: FedraSansStd-book;
              color: #CF4520;
            }
            @media (max-width: 768px) {
             
            }
          `}
        </style>
      </Box>
    </>
  );
};

export default DonationGroupCard;
